var trackers = new Map();
export function addTracker(name, tracker) {
    trackers.set(name, tracker);
    return tracker;
}
export function getTracker(name) {
    return trackers.get(name);
}
export function removeTracker(name) {
    trackers.delete(name);
}
export function getAllTrackers() {
    return trackers.values();
}
export function clearStore() {
    trackers.clear();
}
//# sourceMappingURL=tracker-store.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/tracker-store.js
// module id = 1119
// module chunks = 0